import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import "../employees/index.css";
import { createNewProduct, getAllProduct, updateProductStatus } from "../../../apis/product";
import { Moment } from "moment";
import { successAlert } from "../../../style/scss/utils/Alerts";
import Select from "react-select";
import Newloader from "../employees/loader";
import CommonSearch from "../commonSearch";
import { formatDate } from "../../../environment";
import { getAllProductByType } from "../../../apis/productNameList";
declare module "jspdf" {
  interface jsPDF {
    autoTable: any;
  }
}

type EmployeeResponse = {
  status: string;
  productPrice: any;
  product_price: any;
  emi_type: number;
  name: string;
  Image: string;
  CurrentRole: string;
  rate: number;
  model_no: string;
  createdAt: string;
  id: any;
  Status: string;
};
type EmployeeData = {
  product_price: any;
  key: number;
  Name: string;
  model_no: string;
  id: any;
  rate: number;
  createdAt: string;
  Status: string;
  allData: any;
};

const ProductList = () => {
  const initialValues = {
    type: "",
    name: "",
    rate: "",
    model_no: "",
    product_price: "",
  };
  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [selectedOption_, setSelectedOption_] = useState<any>();
  const [filteredData, setFilteredData] = useState<EmployeeData[]>([]);
  const [loader, setLoader] = useState(false);
  const [productName, setProductName] = useState<any>([]);
  const { name, rate, model_no, product_price } = formData;
  const productData = JSON.parse(sessionStorage.getItem("info"));

  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    fetchAllEmployees();
    productNameListData();
  }, [state, selectedOption]);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "EmployeeData");
    XLSX.writeFile(workbook, "employee_data.xlsx");
  };

  const fetchAllEmployees = async () => {
    setLoader(true);
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllProduct(data);
      const employeeData = response?.data
        ?.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        .map((item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          createdAt: formatDate(item.createdAt),
          Name: `${item.name}`,
          rate: item.rate || "--",
          product_price: item.product_price ?? item.productPrice ?? "--",
          model_no: item.model_no || "--",
          Status: item.status || "active",
          emi_type: item.emi_type || "--",
          id: item.id,
          allData: item,
        }));
      setEmployeeData(employeeData || []);
      setFilteredData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmit = async (event: any) => {
    setLoader(true);
    event.preventDefault();
    const payload = {
      ...formData,
      status: "active",
      product_type: selectedOption?.value,
      financer_id: productData.id,
      emi_type: selectedOption_?.value,
      product_price: Number(formData.product_price) || 0,
    };
    try {
      const response = await createNewProduct(payload);
      if (response.status === true) {
        successAlert("Success", "successfully created new product");
        setFormData(initialValues);
        setSuccessCreation(true);
        fetchAllEmployees();
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const handleStatusChange = async (record: EmployeeData) => {
    const nextStatus = record.Status === "active" ? "inactive" : "active";
    setLoader(true);
    try {
      const response = await updateProductStatus(record.id, nextStatus);
      if (response.status) {
        successAlert("Success", `Product marked ${nextStatus}`);
        fetchAllEmployees();
      }
    } catch (error) {
      console.error("Error updating product status:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleSelect_ = (option: any | null) => {
    setSelectedOption_(option || undefined);
  };

  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
    const newResponse = allEmployeeData.filter((ele, i) => {
      return Number(ele.allData.user_id) === Number(option?.value);
    });
    setFilteredData(newResponse);
  };

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "key",
      render: (_: any, record: EmployeeData) => <div>{record.key}</div>,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{text}</p>
        </div>
      ),
    },
    {
      title: "Product Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record?.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Rate",
      dataIndex: "rate",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record?.rate}</p>
          </div>
        </div>
      ),
    },
    {
      title: "Modal",
      dataIndex: "model_no",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{text}</p>
        </div>
      ),
    },
    {
      title: "Emi Type",
      dataIndex: "emi_type",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{text}</p>
        </div>
      ),

    },
    {
      title: "Product Price",
      dataIndex: "product_price",
      render: (text: string | number) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{text}</p>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (_: any, record: EmployeeData) => (
        <span className={`badge ${record.Status === "active" ? "badge-success" : "badge-danger"}`}>
          {record.Status === "active" ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: EmployeeData) => {
        const isActive = record.Status === "active";
        return (
          <button
            type="button"
            className={`btn btn-sm ${isActive ? "btn-outline-danger" : "btn-outline-success"}`}
            onClick={() => handleStatusChange(record)}
          >
            {isActive ? "Make Inactive" : "Make Active"}
          </button>
        );
      },
    },
  ];
  const productNameListData = async () => {
    const data = {
      user_type: productData.type,
      user_id: productData.id,
      product_type: selectedOption?.value,
    };
    const response = await getAllProductByType(data);

    const formatted = response.data.map((item: any) => ({
      label: item.product_name, // display in the dropdown
      value: item.product_name, // actual value
    }));

    setProductName(formatted);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_employee"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Create New Product
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div>
                    <CommonSearch
                      allEmployeeData={allEmployeeData}
                      setFilteredData={setFilteredData}
                    />
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {filteredData && filteredData.length > 0 && (
                  <Table
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Product</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Product Type <span className="text-danger"> *</span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={[
                              { value: "Device Loan", label: "Device Loan" },
                              { value: "Others Loan", label: "Others Loan " },
                            ]}
                            value={selectedOption}
                            onChange={handleSelect}
                            placeholder="--Select--"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Product Name <span className="text-danger"> *</span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={productName}
                            value={productName.find(
                              (opt: any) => opt.value === formData.name
                            )}
                            onChange={(option: any) =>
                              setFormData({
                                ...formData,
                                name: option?.value || "",
                              })
                            }
                            placeholder="--Select Product Name--"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Interest Rate{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="rate"
                            value={rate}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Modal No.
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="model_no"
                            value={model_no}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            EMI Type <span className="text-danger"> *</span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={[
                              { value: "Flat Rate", label: "Flat Rate" },
                              { value: "Reducing", label: "Reducing " },
                            ]}
                            value={selectedOption_}
                            onChange={handleSelect_}
                            placeholder="--Select--"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Product Price <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="product_price"
                            value={product_price}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      // type="submit"
                      onClick={handleSubmit}
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default ProductList;
